// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"713":"a42d9b10","800":"9dce2a94","823":"6c959ec9","970":"ac700355"}[chunkId] + ".chunk.js";
};